import React, { useEffect, useState } from 'react';
import styles from './error-message.module.scss';
import { Animate } from '../../animation/animation';
import cn from 'classnames';
import { useWindowSize } from '../../common-effects';

interface ErrorMessageProps {
	error?: string
}

const PADDING = 60;
const PIXELS_PER_LETTERS_RATIO = 8.2;

export default function ErrorMessage({ error }:ErrorMessageProps) {
	const [viewLongMessageCondition, setViewConditon] = useState<boolean>(false);
	const errorLengh = Number(error?.length);
	const windowSize = useWindowSize();

	useEffect(() => {
		setViewConditon((windowSize.width - PADDING)/errorLengh < PIXELS_PER_LETTERS_RATIO);

	}, [windowSize, error, setViewConditon, errorLengh]);


	return <Animate name="error-msg" duration={300} effect={styles.active} when={errorLengh > 0}>
		<p className={cn(styles.default, {[styles.longMessageFromMobile]: viewLongMessageCondition })}>{error}</p>
	</Animate>
}